import { lazy, Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
	selectLicense,
	selectForceNormalRegistration,
	selectOneBankIDFlowEnabled,
	selectOneButtonFlow
} from '~/components/brand/ducks/selectors.js';
import { LICENSE_SGA, LICENSE_KSA, LICENSE_OGA } from '~/utils/license-utils.js';
import useRegistration from './use-register.js';
import { selectIsOntarioOnboardingFlowB } from '~/components/authentication/ducks/selectors';
import setUpRegistrationFlowListeners from '~/components/authentication/register/new-register/config/OGA/set-up-registration-flow-listeners';

const RegisterSGA = lazy(() => import(/* webpackChunkName: "register-sga" */ './register-sga.js'));

const RegisterKSA = lazy(() => import(/* webpackChunkName: "register-sga" */ './register-ksa.tsx'));

const RegisterWizard = lazy(() => import(/* webpackChunkName: "register-wizard" */ './registration-wizard.js'));

const RegisterWizardOnboarding = lazy(() => import(/* webpackChunkName: "register-oga" */ './new-register/index'));

const SuspenseWrapper = ({ children }) => <Suspense fallback={<div className="spinner" />}>{children}</Suspense>;

const RegisterComponentMap = {
	[LICENSE_SGA]: RegisterSGA,
	[LICENSE_KSA]: RegisterKSA
};

const Register = ({ campaignRegistration }) => {
	const license = useSelector(selectLicense);
	setUpRegistrationFlowListeners();

	const forceNormalRegistration = useSelector(selectForceNormalRegistration);
	const isOnboardingFlowBEnabled = useSelector(selectIsOntarioOnboardingFlowB);
	const isOntarioFlowBEnabled = license === LICENSE_OGA && isOnboardingFlowBEnabled;

	const RegisterComponent = forceNormalRegistration
		? RegisterWizard
		: (RegisterComponentMap[license] ?? (isOntarioFlowBEnabled ? RegisterWizardOnboarding : RegisterWizard));

	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlow);
	const isPlayNowEnabled = oneBankIDFlowEnabled || oneButtonFlow;
	const { redirectToRegister } = useRegistration();
	// moved this redirection from auth-gateway
	// for franchises that moved from full registration to one button flow, redirect to the correct registration flow
	useEffect(() => {
		if (isPlayNowEnabled) {
			redirectToRegister();
		}
	}, [isPlayNowEnabled, redirectToRegister]);

	if (isPlayNowEnabled) {
		return <div className="spinner" />;
	}
	return (
		<SuspenseWrapper>
			<RegisterComponent campaignRegistration={campaignRegistration} />
		</SuspenseWrapper>
	);
};

export default Register;
